import useIsMobile from '@/hooks/useIsMobile';
import DateRangePickerDesktop from './desktop';
import DateRangePickerMobile from './mobile';
import useDateRangePicker from './useDateRangePicker';

const DateRangePicker = (props) => {
  const isMobile = useIsMobile(992);
  const viewModel = useDateRangePicker();

  if (isMobile) {
    return <DateRangePickerMobile props={props} viewModel={viewModel} />;
  }

  return <DateRangePickerDesktop props={props} viewModel={viewModel} />;
};

export default DateRangePicker;